import { text } from "@nozbe/watermelondb/decorators";
import { BaseModel } from "./Base";

export default class ReceiptTemplateType extends BaseModel {
  static table = "receipt_template_type";
  @text("html") html: string;
  @text("css") css: string;
}
